export default function () {
    const $parent = $('.module-quickcontact');

    if (!$parent.length) {
        return;
    }

    const $infobox = $parent.find('.infobox');
    const $closeIcon = $parent.find('.mobile-close');
    const $bubble = $parent.find('.bubble');
    const $icon = $bubble.find('.icon');

    /**
     * open flyout
     */
    function open() {
        $parent.addClass('open');
        $icon.removeClass('icon-Contact').addClass('icon-Flyout-Close');
    }

    /**
     * close flyout
     */
    function close() {
        $parent.removeClass('open');
        $icon.removeClass('icon-Flyout-Close').addClass('icon-Contact');
    }

    if ($parent.hasClass('open--desktop')) {
        if ($infobox.is(':visible')) {
            open();
        }
        $parent.removeClass('open--desktop');
    }

    // orange bubble
    $bubble.on('click', () => {
        if ($icon.hasClass('icon-Contact')) {
            open();
        } else {
            close();
        }
    });

    // this close-button is only visible inside the opened infobox on mobile
    $closeIcon.on('click', () => {
        close();
    });
}
